import { CreateAdminInfoType } from '../app/admins/NewAdminForm'
import { ApiRoutes } from '../helpers/routes'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/admin`

class AdminService {
    getAll = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.admin.getAll}`, {
            method: 'GET',
        })
    }

    create = async (info: CreateAdminInfoType) => {
        return fetchApi(`${baseUrl}${ApiRoutes.admin.create}`, {
            method: 'POST',
            body: JSON.stringify(info),
        })
    }

    delete = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.admin.delete.replace(':id', id)}`, {
            method: 'DELETE',
        })
    }
}

export default AdminService
